import {Resource, ResourceCollection} from 'simpli-web-sdk'
import {NoneResource} from '@/model/NoneResource'
import {TipoCarroceria} from '@/enums/TipoCarroceria'

export class TipoCarroceriaCollection {
  options() {
    return new ResourceCollection(
      NoneResource,
      Object.values(TipoCarroceria).map(
        (tipo: string) =>
          ({
            $id: tipo,
            $tag: tipo,
          } as Resource)
      )
    )
  }
}
